import api from '@/utils/api';

/**
 * Resend email verification
 * @param {string} token - The token of the user
 * @returns {Promise}
 */
const resendApi = (token) => api.post(`/auth/login/${token}/resend`);

export default resendApi;
